import { connect } from 'react-redux';
import UserGroupDetailView from './UserGroupDetailView.jsx';
import { showSettingsSideMenu, hideSettingsSideMenu }
from 'src/legacy/redux/actions/settings.jsx';
import { fetchUserGroups, fetchUserGroup, createUserGroup, updateUserGroup, removeUserFromUserGroup } from 'src/legacy/redux/actions/userGroups';
import { deselectUser, invalidateUserSelection } from 'src/legacy/redux/actions/selection';
import withUseHooks from 'src/legacy/components/withUseHooks.jsx';
import hasAccess from 'src/legacy/services/hasAccess.jsx';
import _ from 'lodash';

const mapStateToProps = (state, ownProps) => {
  var id = ownProps.params.id;
  var userGroup = _.get(state.legacyRootReducer, `settings.userGroup.userGroup[${id}]`);
  return {
    userGroups: _.get(state.legacyRootReducer, "settings.userGroup.items"),
    userGroup: userGroup && userGroup.item ? userGroup.item : null,
    loading: userGroup && userGroup.loading ? userGroup.loading : false,
    updating: userGroup && userGroup.updating ? userGroup.updating: false,
    creating: _.get(state.legacyRootReducer, "settings.userGroup.creating", false),
    selectedUsers: _.get(state.legacyRootReducer, "selection.users") || [],
    user: state.users.me
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    showSettingsSideMenu: () => {
      dispatch(showSettingsSideMenu());
    },

    hideSettingsSideMenu: () => {
        dispatch(hideSettingsSideMenu())
    },

    fetchUserGroups: (page, query) => {
      return dispatch(fetchUserGroups(page, query));
    },

    fetchUserGroup: (id) => {
      return dispatch(fetchUserGroup(id));
    }, 

    createUserGroup:(request) => {
      return dispatch(createUserGroup(request));
    },

    updateUserGroup:(id, request) => {
      return dispatch(updateUserGroup(id, request));
    },

    removeUserFromUserGroup: (id, user) => {
      return dispatch(removeUserFromUserGroup(id, user));
    },

    deselectUser: (user) => {
      return dispatch(deselectUser(user));
    },

    invalidateUserSelection: () => {
      return dispatch(invalidateUserSelection());
    }
  }
}

const UserGroupDetailPage = connect (
  mapStateToProps,
  mapDispatchToProps
)(UserGroupDetailView);

// export default hasAccess(UserGroupDetailPage, 'user-management');
export default withUseHooks(UserGroupDetailPage);